import { Form, Formik } from "formik";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { handleAPIError } from "../../utils/index.jsx";
import {
  PROPERTY_FISCALITE_FORM_IV,
  propertyFiscaliteSchema,
} from "../../models/property";
import TextInput from "../UI/TextInput.jsx";
import Tooltip from "../UI/Tooltip";
import { Bank, CalendarCheck, Interrogation } from "../UI/Icons.jsx";
import StyledForm from "../UI/StyledForm.jsx";
import Card from "../UI/Card.jsx";
import { useState } from "react";
import AddressFields from "../UI/AddressFields.jsx";

export default function FiscaliteBienForm({ property, onSubmit }) {
  const [error, setError] = useState("");
  const initialValues = {
    ...toInitialValuesFromSchema(
      propertyFiscaliteSchema,
      property,
      PROPERTY_FISCALITE_FORM_IV,
    ),
  };

  async function submitHandler(values, { resetForm }) {
    const sanitizedValues = { ...sanitizeValues(values) };
    try {
      setError("");
      await onSubmit(sanitizedValues);
      resetForm();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={propertyFiscaliteSchema}
      onSubmit={submitHandler}
    >
      {() => (
        <Form>
          <p className={"cardTitle text-center marginB20"}>
            <img src={`/photo_balance.png`} alt="Bien" className={"center"} />
            Modifier les paramètres du bien
          </p>

          <StyledForm
            formElement={<AddressFields nameRue={"rue"} mandatory />}
            label={<div>Adresse</div>}
            icon={<CalendarCheck stroke={"#9D9D9D"} />}
          />
          <StyledForm
            formElement={
              <TextInput type="date" name="date_achat" dependon="id_parent" />
            }
            label={<div>Date d'achat </div>}
            icon={<CalendarCheck stroke={"#9D9D9D"} />}
          />
          <StyledForm
            formElement={
              <TextInput
                type="text"
                name="prix_achat"
                dependon="id_parent"
                unit={"€"}
              />
            }
            label={
              <div>
                Prix d'achat{" "}
                <Tooltip
                  content={
                    "Nécessaire si vous prenez l'offre comptable avec Qalimo. Si immeuble en monopropriété, vous pouvez mettre le prix sur l'immeuble."
                  }
                >
                  <Interrogation />
                </Tooltip>
              </div>
            }
            icon={<Bank stroke={"#9D9D9D"} />}
          />

          <div className={"text-right"}>
            <FormikSubmitButton>Valider</FormikSubmitButton>
          </div>
          {error && <Card type="error marginT10">{error}</Card>}
        </Form>
      )}
    </Formik>
  );
}
